// Marco de la guía de uso (/uso): la cabecera con "volver" y el título, y el cuerpo que se desplaza. Lo usan la guía y su
// esqueleto mientras se descarga (la guía va aparte), así la cabecera no cambia al llegar.
import { Icono } from '@reparto/ui';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';

export function MarcoGuia({ children }: { children: ReactNode }) {
  const navegar = useNavigate();
  // Vuelve a donde estaba (Perfil o Acceso); si la guía se abrió desde un enlace, a la pantalla del día.
  const volver = () => {
    const indice = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (indice > 0) navegar(-1);
    else navegar('/', { replace: true });
  };

  return (
    <div className="flex h-full flex-col">
      <header className="seguro-arriba bg-primary-800 text-white">
        <div className="mx-auto flex w-full max-w-5xl items-center gap-2 px-3 py-2 sm:px-4">
          <button
            type="button"
            onClick={volver}
            className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-white/10"
            aria-label="Volver"
          >
            <Icono nombre="arrow_back" />
          </button>
          <div className="min-w-0 flex-1">
            <h1 className="truncate text-[17px] leading-tight font-medium">Cómo se usa la app</h1>
            <div className="truncate text-xs text-primary-100">Paso a paso, con las pantallas de verdad</div>
          </div>
        </div>
      </header>
      <main className="min-h-0 flex-1 overflow-y-auto">
        <div className="mx-auto w-full max-w-5xl px-4 pt-4 pb-10">{children}</div>
      </main>
    </div>
  );
}
